<template>
    <div>
        <div class="toptitle">人群画像</div>
        <div class="btmcont">
            <div class="btone">
                <div class="chartone" ref="canji"></div>
                <div>残疾类型</div>
            </div>
            <div class="btone">
                <div class="chartone" ref="nianling"></div>
                <div>年龄层</div>
            </div>
            <div class="btone">
                <div class="chartone" ref="xueli"></div>
                <div>学历水平</div>
            </div>
            <div class="btone">
                <div class="chartone" ref="xingbie"></div>
                <div>性别分布</div>
            </div>
        </div>

    </div>
</template>
<script>
import * as echarts from 'echarts';

export default {
    data() {
        return {
            canjiChart: null,
            nianlingChart: null,
            xueliChart: null,
            xingbieChart: null
        }
    },
    mounted() {
        this.getData();
        // this.initCanjiCharts();
        // this.initNianlingCharts()
        // this.initXueliCharts()
        // this.initXingbieCharts()
        // 监听窗口 resize，图表自适应
        window.addEventListener('resize', () => {
            this.canjiChart.resize();
            this.nianlingChart.resize()
            this.xueliChart.resize()
            this.xingbieChart.resize()

        });
    },
    methods: {
        // 人群画像
        getData() {
            this.$api({
                url: '/api/central_control/crowd',
                method: 'POST'
            }).then(res => {
                console.log(res.data)
                // 残疾处理
                let canjires = res.data.disability_category
                let canji = [
                    { value: canjires.limb, name: '肢体', itemStyle: { color: '#376DF7' } },
                    { value: canjires.spirit, name: '精神', itemStyle: { color: '#53B997' } },
                    { value: canjires.vision, name: '智力', itemStyle: { color: '#6750AA' } },
                ]
                let filteredCanji = canji.filter(item => item.value != 0)
                this.initCanjiCharts(filteredCanji);
                // 年龄处理
                let nianlingData = Object.values(res.data.age)
                this.initNianlingCharts(nianlingData)
                // 学历
                this.initXueliCharts(res.data.qualification)
                // 性别
                this.initXingbieCharts(res.data.gender)
            })
        },
        // 性别分布
        initXingbieCharts(data) {
            this.xingbieChart = echarts.init(this.$refs.xingbie);
            let option = {
                tooltip: {
                    trigger: 'item'
                },
                series: [
                    {
                        type: 'pie',
                        radius: '50%',
                        label: {
                            show: true,
                            position: 'inner',
                            color: '#fff'
                        },
                        data: [
                            {
                                value: data.female, name: '女', itemStyle: {
                                    color: new echarts.graphic.LinearGradient(
                                        0, 0, 1, 1,// 圆心 x、y（0.5 为中心），半径 0.5
                                        [
                                            { offset: 0, color: '#FF72A6' },
                                            { offset: 1, color: '#FF3657' }
                                        ]
                                    )
                                }
                            },
                            {
                                value: data.male, name: '男', itemStyle: {
                                    color: new echarts.graphic.LinearGradient(
                                        0, 0, 1, 1,// 圆心 x、y（0.5 为中心），半径 0.5
                                        [
                                            { offset: 0, color: '#60F5FF' },
                                            { offset: 1, color: '#3FA4FF' }
                                        ]
                                    )
                                }
                            },

                        ],

                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };
            // 使用配置项生成图表
            this.xingbieChart.setOption(option);

        },
        // 学历水平折线图
        initXueliCharts(data) {
            this.xueliChart = echarts.init(this.$refs.xueli);
            let option = {
                tooltip: {
                    trigger: 'axis'
                },
                xAxis: {
                    type: 'category',
                    data: ['小学', '初中', '高中', '大专', '本科'],
                    axisLabel: {
                        color: '#fff',
                        fontSize: 10
                    },
                },
                yAxis: {
                    type: 'value',
                    show: false,
                    axisLabel: {
                        color: '#616E88',
                        fontSize: 9
                    },
                },
                series: [
                    {
                        data: [data.primary_school, data.middle_school, data.high_school, data.associate_degree, data.college],
                        type: 'line',
                        lineStyle: {
                            color: '#61DBED'
                        },
                        // 可选：设置折点颜色
                        itemStyle: {
                            color: '#61DBED',
                        },
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(
                                0, 0,  // 渐变起始点坐标（左上角）
                                0, 1,  // 渐变结束点坐标（左下角，垂直向下渐变）
                                [
                                    { offset: 0, color: 'rgba(97, 219, 237, 0.24)' },  // 起始色（透明度 24%）
                                    { offset: 1, color: 'rgba(97, 219, 237, 0)' }     // 结束色（完全透明）
                                ]
                            )
                        },
                    }
                ]
            }
            // 使用配置项生成图表
            this.xueliChart.setOption(option);
        },
        // 年龄
        initNianlingCharts(data) {
            this.nianlingChart = echarts.init(this.$refs.nianling);
            let option = {
                tooltip: {
                    trigger: 'axis'
                },
                xAxis: {
                    type: 'category',
                    data: ['20-30', '30-40', '40-50', '50-60'],
                    axisLabel: {
                        color: '#fff',
                        fontSize: 10
                    },
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        color: '#616E88',
                        fontSize: 9
                    },
                },
                series: [
                    {
                        data,
                        type: 'bar',
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(
                                0, 0, 1, 1,// 圆心 x、y（0.5 为中心），半径 0.5
                                [
                                    { offset: 0, color: '#1DDDFE' },
                                    { offset: 1, color: '#2D6AF2' }
                                ]
                            )
                        }
                    }
                ]
            };
            // 使用配置项生成图表
            this.nianlingChart.setOption(option);


        },
        // 残疾类型
        initCanjiCharts(data) {
            this.canjiChart = echarts.init(this.$refs.canji);
            let option = {

                tooltip: {
                    trigger: 'item'
                },
                series: [
                    {
                        type: 'pie',
                        radius: '50%',
                        label: {
                            show: true,
                            position: 'inner',
                            color: '#fff'
                        },
                        data,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };
            // 使用配置项生成图表
            this.canjiChart.setOption(option);

        },

    }
}
</script>
<style lang="less" scoped>
.btmcont {
    background: url('@/assets/conbgBig.png') no-repeat 0 0/100% 100%;
    width: 100%;
    height: calc(((100vh - 100px) / 2) - 50px);
    padding: 10px 26px;
    color: #fff;
    display: flex;
    justify-content: center;

    .btone {
        width: 25%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        font-weight: bold;
        font-size: 14px;
        color: #E4E4E4;
        padding: 20px 0;

        .chartone {
            width: 100%;
            height: 300px;
            // height: 00px;
        }
    }
}
</style>